import React from 'react'
import { I18n } from '@front/volcanion'

import { ConfirmationDialog } from '@front/squirtle'

const DialogManager = ({ onConfirmResetIdentifier }) => <>
  <ConfirmationDialog
    name={'confirmation_reset'}
    title={I18n.t('identifier.reset.title')}
    description={I18n.t('identifier.reset.description')}
    onConfirm={onConfirmResetIdentifier}
  />
</>

export default React.memo(DialogManager)
